// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal } from 'antd'
import { get, includes, defaultTo, isNil } from 'lodash'

// Ressources
import { actions as operationActions } from 'Resources/OperationResource'

// Common components
import { ManageModal } from 'Components'

// Specs
import { ModalSpecs } from 'Views/Operations/Specs'

// Ãcrans
import { List } from './Screens'
import { formatOrderedData } from 'Helpers/index'

const { confirm } = Modal

class OperationsConstructor extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    operation: PropTypes.object,
    operations: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired,
      setParams: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    operation: {},
    operations: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchOperationsData()

    if (this.getContext() === 'single') {
      this.getOperationData().then(this.askUpdateOperation)
    }
  }

  /**
   * RÃ©cupÃ©ration du contexte actuel du constructeur de page
   */
  getContext = () => {
    return isNil(this.props.navigation.getParam('id')) ? 'list' : 'single'
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchOperationsData = () => {
    this.props.actions.fetchOperations().catch(() => {
      message.error(I18n.t('api.errors.operation.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getOperationData = (operation = this.props.navigation.getParam('id')) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getOperation(operation)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.operation.get'))
        })
    })

  /**
   * Actions groupÃ©es:
   * Archivage de plusieurs lignes du tableau
   */
  archiveManyOperation = (operation, clearTableSelections) => {
    this.props.actions
      .archiveManyOperation(operation)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.operation.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.operation.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveOperation = operation => {
    this.props.actions
      .archiveOperation(operation)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.operation.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.operation.archive'))
      })
  }

  /**
   * Actions groupÃ©es:
   * Suppression de plusieurs lignes du tableau
   */
  deleteManyOperation = (operation, clearTableSelections) => {
    this.props.actions
      .archiveOperations(operation)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.operation.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.operation.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteOperation = operation => {
    this.props.actions
      .archiveOperation(operation)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.operation.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.operation.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un operation
   */
  updateOperation = (updatedOperation, originalOperation) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateOperation({
          id: get(originalOperation, 'id'),
          ...updatedOperation
        })
        .then(response => {
          this.safelyCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.operation.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.operation.update'))
        })
    })

  /**
   * CrÃ©ation d'un operation
   */
  createOperation = createdOperation =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createOperation(createdOperation)
        .then(response => {
          this.safelyCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.operation.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.operation.create'))
        })
    })

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveManyOperations = (...params) => {
    confirm({
      title: I18n.t('pages.operations.modal.archive.multiple.title'),
      content: I18n.t('pages.operations.modal.archive.multiple.content'),
      okText: I18n.t('pages.operations.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.operations.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveOperation(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveOperation = () => {
    const { operation } = this.props

    confirm({
      title: I18n.t('pages.operations.modal.archive.single.title'),
      content: I18n.t('pages.operations.modal.archive.single.content'),
      okText: I18n.t('pages.operations.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.operations.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveOperation(operation)
      },
      maskClosable: true
    })
  }

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteManyOperations = (...params) => {
    confirm({
      title: I18n.t('pages.operations.modal.delete.multiple.title'),
      content: I18n.t('pages.operations.modal.delete.multiple.content'),
      okText: I18n.t('pages.operations.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.operations.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteManyOperation(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteOperation = () => {
    const { operation } = this.props

    confirm({
      title: I18n.t('pages.operations.modal.delete.single.title'),
      content: I18n.t('pages.operations.modal.delete.single.content'),
      okText: I18n.t('pages.operations.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.operations.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteOperation(operation)
      },
      maskClosable: true
    })
  }

  /**
   * Demande de modification d'une ligne du tableau
   */
  askUpdateOperation = () => {
    this.setState({ openedModal: 'updateOperation' })
  }

  /**
   * Demande de crÃ©ation d'une ligne du tableau
   */
  askCreateOperation = () => {
    this.setState({ openedModal: 'createOperation' })
  }

  /**
   * Fermeture de toutes les modales
   */
  safelyCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateOperation') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(
          this.setState({ openedModal: null }, () => {
            this.props.navigation.setParams({ id: null })
          }),
          200
        )
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleRowCreated = () => {
    this.safelyCloseModal()
  }

  /**
   * Callback:
   * Modification d'une ligne de tableau rÃ©ussie
   */
  handleRowUpdated = () => {
    this.safelyCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = operation => {
    // Navigation vers la page dÃ©taillÃ©e
    this.props.navigation.setParams({ id: get(operation, 'id') })

    this.getOperationData(operation)
      .then(() =>
        // Ouverture de la modale
        this.askUpdateOperation()
      )
      .catch(() => {
        this.props.navigation.setParams({ id: null })
      })

    // Ouverture du drawer
    // this.setState({ drawerOpened: true })

    // Navigation vers la vue dÃ©taillÃ©e
    // this.props.navigation.navigate('Operation', { id: get(operation, 'id') })
  }

  handleDraggedRowReleased = orderedData => {
    const formattedOrderedData = formatOrderedData(orderedData)

    this.props.actions
      .orderOperation(formattedOrderedData)
      .then(() => message.success(I18n.t('api.success.operation.order')))
      .catch(() => message.error(I18n.t('api.errors.operation.order')))
  }

  /**
   * Formatage des lignes de la modale de modification / crÃ©ation
   */
  formatModalRows = rows => {
    return rows
  }

  render() {
    // RÃ©cupÃ©ration des Ã©lÃ©ments des props
    let {
      isGathering,
      isUpdating,
      isCreating,
      operations,
      operation
    } = this.props

    // RÃ©cupÃ©ration des Ã©lÃ©ments du state
    const { openedModal } = this.state

    // Chargement
    const loading = isGathering || isUpdating || isCreating

    // CrÃ©ation de la liste des fonctions constructeur exposÃ©s au Ã©crans
    const constructorFunctions = {
      // Clic sur un ligne de tableau
      handleRowClick: this.handleRowClick,

      // Gestion de la modale
      safelyCloseModal: this.safelyCloseModal,

      // RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'une ligne du tableau
      getOperationData: this.getOperationData,

      // CrÃ©ation d'une ligne de tableau
      handleRowCreated: this.handleRowCreated,
      askCreateOperation: this.askCreateOperation,

      // Modification d'une ou plusieurs ligne(s) de tableau
      handleRowUpdated: this.handleRowUpdated,
      askUpdateOperation: this.askUpdateOperation,
      askUpdateManyOperations: this.askUpdateOperation,

      handleDraggedRowReleased: this.handleDraggedRowReleased,

      // Archivage d'une ou plusieurs ligne(s) du tableau
      askArchiveOperation: this.askArchiveOperation,
      askArchiveManyOperations: this.askArchiveManyOperations,

      // Suppression d'une ou plusieurs ligne(s) du tableau
      askDeleteOperation: this.askDeleteOperation,
      askDeleteManyOperations: this.askDeleteManyOperations,

      // RÃ©initialisation du mot de passe d'un operation
      askResetPasswordOperation: this.askResetPasswordOperation
    }

    // Ajout des actions sur la modale
    ModalSpecs.actions.delete.onClick = this.askDeleteOperation

    // Ajout des lignes au formulaire
    // formLayout = merge(formLayout, manageModal)

    return (
      <Fragment>
        {/* Rendu de l'Ã©cran appropriÃ© au contexte du constructeur */}
        <List
          loading={loading}
          constructorFunctions={constructorFunctions}
          constructorState={this.state}
          data={operations}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          width={800}
          loading={loading}
          onCancel={this.safelyCloseModal}
          onOk={this.handleRowCreated}
          onChange={
            openedModal === 'updateOperation'
              ? this.updateOperation
              : this.createOperation
          }
          visible={includes(
            ['createOperation', 'updateOperation'],
            openedModal
          )}
          data={
            includes(['transition', 'updateOperation'], openedModal)
              ? operation
              : null
          }
          {...ModalSpecs}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(OperationsConstructor, 'defaultProps', {})

  return {
    operations: defaultTo(
      get(state, 'operation.items'),
      defaultProps.operations
    ),
    operation: defaultTo(get(state, 'operation.item'), defaultProps.operation),
    isGathering:
      defaultTo(get(state, 'operation.isFetching'), defaultProps.isGathering) ||
      defaultTo(
        get(state, 'operation.isFetchingItem'),
        defaultProps.isGathering
      ),
    isUpdating: defaultTo(
      get(state, 'operation.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...operationActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OperationsConstructor)
